import React, { useState } from "react";
import api from "../../../../api/client";

const MORE_TIME_OPTIONS = [1, 2, 3, 7, 14];

// Reassign a fix to someone else, or give its fixer more time. Both put it
// back to open and message whoever now has it.
export default function FixActionDialog({ fix, action, users, onClose, onDone }) {
  const reassigning = action === "reassign";
  const [fixerId, setFixerId] = useState("");
  const [days, setDays] = useState(2);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const others = users.filter((u) => u.id !== fix.fixer?.id);

  const submit = async (e) => {
    e.preventDefault();
    if (reassigning && !fixerId) return setError("Pick who should fix it.");
    setSaving(true);
    setError("");
    try {
      if (reassigning) {
        await api.post(`/manufacturing/allotted-tasks/fixes/${fix.id}/reassign`, { fixerId });
        onDone("Fix reassigned");
      } else {
        await api.post(`/manufacturing/allotted-tasks/fixes/${fix.id}/extend`, { days: Number(days) });
        onDone("More time given");
      }
    } catch (err) {
      setError(err.response?.data?.error || "Couldn't update the fix.");
      setSaving(false);
    }
  };

  return (
    <div className="at-modal-backdrop" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="at-modal" role="dialog" aria-modal="true" aria-label={reassigning ? "Reassign fix" : "Give more time"} style={{ maxWidth: 460 }}>
        <div className="at-modal-head">
          <h3>{reassigning ? "Reassign fix" : "Give more time"}</h3>
          <button type="button" className="at-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <form onSubmit={submit}>
          {error && <div className="at-error">{error}</div>}

          <div className="at-field">
            <span className="at-label">{fix.title}</span>
            {fix.reason && <p className="at-hint" style={{ marginTop: 0 }}>“{fix.reason}”</p>}
            {fix.blockedReason && <p className="at-hint" style={{ marginTop: 0 }}>Can't fix: “{fix.blockedReason}”</p>}
          </div>

          {reassigning ? (
            <label className="at-field at-fix-field">
              <span className="at-fix-label">Who fixes it now</span>
              <select className="at-select" value={fixerId} onChange={(e) => { setFixerId(e.target.value); setError(""); }} autoFocus>
                <option value="">Pick a person</option>
                {others.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
              </select>
            </label>
          ) : (
            <label className="at-field at-fix-field">
              <span className="at-fix-label">{fix.fixer?.name} has until</span>
              <select className="at-select" value={days} onChange={(e) => setDays(e.target.value)} autoFocus>
                {MORE_TIME_OPTIONS.map((d) => (
                  <option key={d} value={d}>{d === 7 ? "1 week from today" : d === 14 ? "2 weeks from today" : `${d} ${d === 1 ? "day" : "days"} from today`}</option>
                ))}
              </select>
            </label>
          )}

          <p className="at-hint">
            {reassigning
              ? "They get the fix on Telegram or WhatsApp with a fresh deadline, and it shows in their My Tasks."
              : "The fixer is messaged with the new date and reminders start again."}
          </p>

          <div className="at-modal-foot">
            <button type="button" className="at-btn-cancel" onClick={onClose} disabled={saving}>Cancel</button>
            <button type="submit" className="at-btn-primary" disabled={saving}>
              {saving ? "Saving…" : reassigning ? "Reassign" : "Give more time"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
